import React from 'react'

const RecordingContext = React.createContext({
  name: 'recordingContext'
})

export default RecordingContext
